import React, { useState } from "react";
import { VerifyOTPFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Countdown from "react-countdown";
import { useTranslation } from "react-i18next";
import { Inputs, Buttons, Icons } from "components";

const VerifyOTPForm = ({
  email,
  phoneNumber,
  onSubmit,
  onCancel,
  onClickResendOTP,
}) => {
  const schema = yup.object().shape({
    code: yup.string().required("Code required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { t } = useTranslation(["common", "form"]);

  const [_resendBtnDisabled, _setResendBtnDisabled] = useState(true);

  const _onClickResendOTP = () => {
    _setResendBtnDisabled(true);
    onClickResendOTP && onClickResendOTP();
  };

  const _onComplete = () => {
    _setResendBtnDisabled(false);
  };

  return (
    <VerifyOTPFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="v_otp_title">
          {t("Verify your identity", { ns: "form" })}
        </div>
        <div className="v_otp_sub_title">
          {t("The verification code has been sent to", { ns: "form" })}
          {` ${phoneNumber}`}
        </div>
        <div className="v_otp_code_row">
          <div className="cr_left_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.TextField
                  {...field}
                  placeholder={t("OTP code", { ns: "common" })}
                  errors={errors.code?.message}
                />
              )}
              name="code"
              defaultValue=""
            />
          </div>
          <div className="cr_right_col">
            <Buttons.BgIconPrefix
              icon={<Icons.Resend />}
              label={t("Resend", { ns: "common" })}
              disabled={_resendBtnDisabled}
              onClick={_onClickResendOTP}
            />
          </div>
        </div>
        <div className="otp_detail">
          {_resendBtnDisabled && (
            <Countdown
              date={Date.now() + 60000 * 5}
              renderer={({ minutes, seconds }) => (
                <div>
                  0{minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                </div>
              )}
              onComplete={_onComplete}
            />
          )}
          {t("The OTP code will be sent within 5 minutes", { ns: "form" })}
        </div>
        {email && (
          <>
            <div className="info_cf_block">
              <div className="ifc_label">{`อีเมลของท่านคือ\nYoure email is`}</div>
              <div className="ifc_value">{email}</div>
            </div>
            <div className="ifc_warning_txt">
              {
                "หากอีเมลของท่านไม่ถูกต้อง กรุณากดยกเลิกแล้วเริ่มต้นใหม่\nIf your email is incorrect, please cancel and restart."
              }
            </div>
          </>
        )}
        <div className="v_otp_action_row">
          <div className="v_otp_a_col">
            <Buttons.BgIconPrefix
              theme_cancel
              icon={<Icons.Cancel />}
              label={t("Cancel", { ns: "common" })}
              onClick={onCancel}
            />
          </div>
          <div className="v_otp_a_col">
            <Buttons.BgIconPrefix
              type="submit"
              icon={<Icons.Confirm />}
              label={t("Confirm", { ns: "common" })}
            />
          </div>
        </div>
      </form>
    </VerifyOTPFormStyled>
  );
};

VerifyOTPForm.propTypes = {};

export default VerifyOTPForm;
